import { Card, CardContent, Divider, Grid, Stack, Typography } from '@mui/material'
import AgriAction from 'agriAdministration/actions/AgriAction'
import IntervenantCard from 'exploitations/components/cards/IntervenantCard'
import IntervenantModal from 'exploitations/components/modal/IntervenantModal'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import ContributorDto from 'referencial/components/contributor/dto/ContributorDto'
import i18n from 'simple-react-i18n'
import DtoIntervenantDeclaration from 'survey/dto/DtoIntervenantDeclaration'
import { deepEqual } from 'utils/FormUtils'
import { formatSiret, getSandreLabel } from 'utils/StringUtil'
import ProgressCard from 'components/card/ProgressCard'
import { CardTitle } from 'components/card/NewCard'
import { useParams } from 'react-router'

const DeclarationSamplerStep = ({ readMode }) => {
    const [openModalIntervenant, setOpenModalIntervenant] = useState(false)
    const [samplerLoaded, setSamplerLoaded] = useState(true)
    const [newPreleveur, setNewPreleveur] = useState(new ContributorDto({}))

    const {
        exploitation,
        declarationContributors,
        contributors,
        sandreCodes,
    } = useSelector(store => ({
        exploitation: store.AgriReducer.exploitation,
        declarationContributors: store.AgriReducer.declarationContributors,
        contributors: store.ContributorReducer.contributors,
        sandreCodes: store.ReferencialReducer.sandreCodes,
    }), shallowEqual)

    const dispatch = useDispatch()
    const params = useParams()
    const idSurvey = parseInt(params.id)

    useEffect(() => {
        setSamplerLoaded(false)
        const originalPreleveur = contributors.find((c) => c.id === exploitation.operatorCode)
        const updatedPreleveur = declarationContributors.find(
            (updateC) =>
                originalPreleveur.id === updateC.idContributor &&
                idSurvey === updateC.surveyId &&
                updateC.contactType === 1,
        )
        const preleveur = {
            ...originalPreleveur,
            ...updatedPreleveur,
        }
        setNewPreleveur(preleveur)
        setSamplerLoaded(true)
    }, [contributors, declarationContributors, exploitation, idSurvey])

    useEffect(() => {
        if (!declarationContributors.length) dispatch(AgriAction.fetchDeclarationContributors(idSurvey))
    }, [])

    const onSave = (intervenant) => {
        const preleveur = contributors.find((c) => c.id === exploitation.operatorCode)
        const originalPreleveur = new DtoIntervenantDeclaration({
            ...preleveur,
            idContributor: preleveur.id,
            surveyId: idSurvey,
        })
        const updatedPreleveur = new DtoIntervenantDeclaration({
            ...intervenant,
            idContributor: intervenant.id,
            surveyId: idSurvey,
        })
        setOpenModalIntervenant(false)
        if (!deepEqual(originalPreleveur, updatedPreleveur)) {
            dispatch(AgriAction.updateDeclarationContributor(
                idSurvey,
                new DtoIntervenantDeclaration({
                    ...intervenant,
                    idContributor: preleveur.id,
                    surveyId: idSurvey,
                    contactType: 1,
                }),
            ))
        }
    }

    const onCancel = () => {
        setOpenModalIntervenant(false)
    }

    const getModalIntervenant = () => {
        return openModalIntervenant && (
            <IntervenantModal
                intervenant={newPreleveur}
                open={openModalIntervenant}
                onCancel={onCancel}
                onValidate={onSave}
                declarationMode
            />
        )
    }
    return (
        <Stack spacing={1}>
            {samplerLoaded ? (
                <>
                    {newPreleveur && (
                        <Card>
                            <CardTitle title={i18n.description} />
                            <CardContent>
                                <Stack direction={'row'} spacing={2} divider={<Divider orientation='vertical' flexItem />} >
                                    <Grid container>
                                        <Typography sx={{ fontWeight: 'bold' }}>{i18n.codification}</Typography> : {exploitation.codification || ''}
                                    </Grid>
                                    <Grid container>
                                        <Typography sx={{ fontWeight: 'bold' }}>{i18n.name}</Typography> : {newPreleveur.internalIdentifier || newPreleveur.name}
                                    </Grid>
                                    <Grid container>
                                        <Typography sx={{ fontWeight: 'bold' }}>{i18n.type}</Typography> : {getSandreLabel(sandreCodes, 'INTERVENANTS.TYPE_STRUCTURE', newPreleveur.structureType)}
                                    </Grid>
                                    <Grid container>
                                        <Typography sx={{ fontWeight: 'bold' }}>{i18n.siret}</Typography> : {formatSiret(newPreleveur.siret)}
                                    </Grid>
                                </Stack>
                            </CardContent>
                        </Card>
                    )}
                    <Grid container justifyContent='center'>
                        <Grid size={4}>
                            <IntervenantCard
                                intervenant={newPreleveur}
                                title={i18n.sampler}
                                actions={readMode ?
                                    []
                                    :
                                    [
                                        {
                                            onClick: () => setOpenModalIntervenant(true),
                                            icon: 'edit',
                                            color: 'white',
                                        },
                                    ]
                                }
                                contributor
                            />
                        </Grid>
                    </Grid>
                    {getModalIntervenant()}
                </>
            ) : (
                <Grid size={12}>
                    <ProgressCard withMessage indeterminate round />
                </Grid>
            )}
        </Stack>
    )
}

DeclarationSamplerStep.propTypes = {
    readMode: PropTypes.bool,
}

export default DeclarationSamplerStep
